// mock-patient-measures.ts

import { DashboardMeasurePatient } from "@models/dashboard-measure-patient.model";


export const mockPatientMeasures: DashboardMeasurePatient[] = [
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Apr 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "345678912",
    "providerName": "Bennett, Randy"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "234567891",
    "providerName": "William, Harriet"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "345678912",
    "providerName": "Bennett, Randy"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Apr 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "345678912",
    "providerName": "Bennett, Randy"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "345678912",
    "providerName": "Bennett, Randy"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Jan 17, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1003",
    "measureName": "AAO21",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "129",
    "firstName": "Mike",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 65,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "130",
    "firstName": "Rudy",
    "lastName": "Michaels",
    "race": "Black",
    "gender": "Male",
    "age": 67,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H93.2",
    "diagDesc": "Abnormal auditory perception",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "131",
    "firstName": "Bruce",
    "lastName": "Wyatt",
    "race": "White",
    "gender": "Male",
    "age": 68,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H93.2",
    "diagDesc": "Abnormal auditory perception",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "132",
    "firstName": "Joran",
    "lastName": "Pink",
    "race": "Asian",
    "gender": "Male",
    "age": 69,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "133",
    "firstName": "Wendell",
    "lastName": "Wright",
    "race": "White",
    "gender": "Male",
    "age": 70,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "134",
    "firstName": "Chris",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 89,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "135",
    "firstName": "Hank",
    "lastName": "Howard",
    "race": "White",
    "gender": "Male",
    "age": 88,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "136",
    "firstName": "Carrie",
    "lastName": "Middleton",
    "race": "Black",
    "gender": "Female",
    "age": 78,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H93.2",
    "diagDesc": "Abnormal auditory perception",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "137",
    "firstName": "Kim",
    "lastName": "Lunney",
    "race": "Asian",
    "gender": "Female",
    "age": 91,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H93.01",
    "diagDesc": "Transient ischemic deafness",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "138",
    "firstName": "Harriet",
    "lastName": "Feathers",
    "race": "Black",
    "gender": "Female",
    "age": 62,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H93.01",
    "diagDesc": "Transient ischemic deafness",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "139",
    "firstName": "Jessica",
    "lastName": "Slappy",
    "race": "Black",
    "gender": "Female",
    "age": 61,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "0212T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "140",
    "firstName": "Alla",
    "lastName": "Oliveto",
    "race": "Asian",
    "gender": "Female",
    "age": 60,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H93.2",
    "diagDesc": "Abnormal auditory perception",
    "procedureCode": "0212T",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "141",
    "firstName": "Heather",
    "lastName": "Stenson",
    "race": "Black",
    "gender": "Female",
    "age": 80,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "142",
    "firstName": "Omar",
    "lastName": "Santana",
    "race": "Black",
    "gender": "Female",
    "age": 70,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H83.3",
    "diagDesc": "Noise-induced hearing loss",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "143",
    "firstName": "Tadd",
    "lastName": "Carlson",
    "race": "White",
    "gender": "Male",
    "age": 66,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "144",
    "firstName": "Jerry",
    "lastName": "Squires",
    "race": "White",
    "gender": "Male",
    "age": 85,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H83.3",
    "diagDesc": "Noise-induced hearing loss",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "145",
    "firstName": "Mark",
    "lastName": "Barnacle",
    "race": "White",
    "gender": "Male",
    "age": 84,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H93.01",
    "diagDesc": "Transient ischemic deafness",
    "procedureCode": "0210T",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "146",
    "firstName": "Elden",
    "lastName": "Jones",
    "race": "Asian",
    "gender": "Male",
    "age": 83,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "147",
    "firstName": "Eric",
    "lastName": "Olterton",
    "race": "White",
    "gender": "Male",
    "age": 82,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H93.2",
    "diagDesc": "Abnormal auditory perception",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "148",
    "firstName": "Ben",
    "lastName": "Hilts",
    "race": "Black",
    "gender": "Male",
    "age": 80,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H83.3",
    "diagDesc": "Noise-induced hearing loss",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "149",
    "firstName": "Brett",
    "lastName": "Brotherton",
    "race": "White",
    "gender": "Male",
    "age": 79,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "150",
    "firstName": "Olive",
    "lastName": "Oil",
    "race": "Asian",
    "gender": "Female",
    "age": 66,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "151",
    "firstName": "Andrea",
    "lastName": "Williams",
    "race": "White",
    "gender": "Female",
    "age": 62,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "152",
    "firstName": "Carla",
    "lastName": "Masterson",
    "race": "Asian",
    "gender": "Female",
    "age": 61,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H83.3",
    "diagDesc": "Noise-induced hearing loss",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "153",
    "firstName": "Mildred",
    "lastName": "Munson",
    "race": "Black",
    "gender": "Female",
    "age": 63,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H93.2",
    "diagDesc": "Abnormal auditory perception",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 18, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "154",
    "firstName": "Myra",
    "lastName": "Thomas",
    "race": "White",
    "gender": "Female",
    "age": 64,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H93.2",
    "diagDesc": "Abnormal auditory perception",
    "procedureCode": "0210T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "155",
    "firstName": "Tammy",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 66,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H93.01",
    "diagDesc": "Transient ischemic deafness",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1004",
    "measureName": "AAO16",
    "location": "Loc 1001",
    "patientID": "156",
    "firstName": "Sally",
    "lastName": "Henderson",
    "race": "White",
    "gender": "Female",
    "age": 77,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H91",
    "diagDesc": "Unspecified hearing loss, unspecified ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 25,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 16,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 18,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 21,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 28,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 32,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0209T",
    "procedureDate": "Friday, Apr 04, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 44,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 33,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 25,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 19,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 17,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 29,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0212T",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 40,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 41,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 35,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 34,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 18,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0210T",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 22,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 26,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 21,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 22,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 45,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0208T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 54,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 39,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 28,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 18, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 46,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0210T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 35,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "2",
    "measureName": "AAO23",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 19,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 25,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70490",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 16,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 18,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70492",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 21,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70552",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 28,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70552",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 32,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 44,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 33,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70552",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 25,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 19,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70543",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 17,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70551",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 29,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70553",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 40,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70553",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 41,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 35,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70553",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 34,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 18,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70552",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 22,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70552",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 26,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 21,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70552",
    "procedureDate": "Friday, Apr 04, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 22,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70552",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 45,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70552",
    "procedureDate": "Monday, Apr 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 54,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 39,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70552",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 28,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70552",
    "procedureDate": "Tuesday, Feb 18, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 46,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "70552",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 35,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1036",
    "measureName": "AAO13",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 19,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "G51.0",
    "diagDesc": "Bell\'s palsy",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Friday, Apr 04, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 1,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 18, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1040",
    "measureName": "AAO37",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Friday, Apr 04, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 1,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 18, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1035",
    "measureName": "AAO12",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Friday, Apr 04, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1005",
    "measureName": "AAO20",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "345678912",
    "providerName": "Bennett, Randy"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "234567891",
    "providerName": "William, Harriet"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "345678912",
    "providerName": "Bennett, Randy"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "234567891",
    "providerName": "William, Harriet"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "345678912",
    "providerName": "Bennett, Randy"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "345678912",
    "providerName": "Bennett, Randy"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1039",
    "measureName": "AAO36",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "345678912",
    "providerName": "Bennett, Randy"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "234567891",
    "providerName": "William, Harriet"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "456789123",
    "providerName": "Cousy, Jane"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 1,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "345678912",
    "providerName": "Bennett, Randy"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1037",
    "measureName": "AAO32",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "345678912",
    "providerName": "Bennett, Randy"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "345678912",
    "providerName": "Bennett, Randy"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1041",
    "measureName": "AAO38",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1042",
    "measureName": "AAO39",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 25,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.00",
    "diagDesc": "Acute maxillary sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Ciprofloxacin Oral Liquid Product",
    "medicationDate": "Thursday, Jan 09, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 16,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.01",
    "diagDesc": "Acute recurrent maxillary sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 18,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.10",
    "diagDesc": "Acute frontal sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Ciprofloxacin Oral Product",
    "medicationDate": "Monday, Feb 10, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 21,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.11",
    "diagDesc": "Acute recurrent frontal sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Cefuroxime Oral Product",
    "medicationDate": "Wednesday, Apr 09, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 28,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "J01.20",
    "diagDesc": "Acute ethmoidal sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 32,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.21",
    "diagDesc": "Acute recurrent ethmoidal sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Amoxicillin / Clavulanate Oral Liquid Product",
    "medicationDate": "Tuesday, Mar 11, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 44,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.30",
    "diagDesc": "Acute sphenoidal sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 33,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.31",
    "diagDesc": "Acute recurrent sphenoidal sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Amoxicillin / Clavulanate Oral Liquid Product",
    "medicationDate": "Tuesday, Feb 11, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 25,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.40",
    "diagDesc": "Acute pansinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 19,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.41",
    "diagDesc": "Acute recurrent pansinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Clindamycin Oral Product",
    "medicationDate": "Monday, Feb 10, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 17,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.80",
    "diagDesc": "Other acute sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Clindamycin Oral Product",
    "medicationDate": "Thursday, Jan 09, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 29,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.81",
    "diagDesc": "Other acute recurrent sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Clindamycin Oral Product",
    "medicationDate": "Friday, Mar 21, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 40,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.90",
    "diagDesc": "Acute sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 41,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.91",
    "diagDesc": "Acute recurrent sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 35,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.00",
    "diagDesc": "Acute maxillary sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Ofloxacin Oral Product",
    "medicationDate": "Monday, Feb 10, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 34,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.01",
    "diagDesc": "Acute recurrent maxillary sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 18,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.10",
    "diagDesc": "Acute frontal sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Vancomycin Oral Product",
    "medicationDate": "Sunday, Feb 09, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 22,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.11",
    "diagDesc": "Acute recurrent frontal sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "cefdinir Oral Liquid Product",
    "medicationDate": "Tuesday, Mar 11, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 26,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "J01.20",
    "diagDesc": "Acute ethmoidal sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 21,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.21",
    "diagDesc": "Acute recurrent ethmoidal sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 22,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.30",
    "diagDesc": "Acute sphenoidal sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 45,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.31",
    "diagDesc": "Acute recurrent sphenoidal sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "cefdinir Oral Product",
    "medicationDate": "Monday, Feb 10, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 54,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.40",
    "diagDesc": "Acute pansinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 39,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.41",
    "diagDesc": "Acute recurrent pansinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Oxytetracycline Oral Product",
    "medicationDate": "Friday, Mar 21, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 28,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.80",
    "diagDesc": "Other acute sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "linezolid Oral Liquid Product",
    "medicationDate": "Monday, Apr 28, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 46,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.81",
    "diagDesc": "Other acute recurrent sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Levofloxacin Oral Liquid Product",
    "medicationDate": "Tuesday, Feb 11, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 35,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.90",
    "diagDesc": "Acute sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1006",
    "measureName": "QPP331",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 19,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.91",
    "diagDesc": "Acute recurrent sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 25,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.00",
    "diagDesc": "Acute maxillary sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "lomefloxacin Oral Product",
    "medicationDate": "Thursday, Jan 09, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 16,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.01",
    "diagDesc": "Acute recurrent maxillary sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 18,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.10",
    "diagDesc": "Acute frontal sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Sulfatrim Oral Product",
    "medicationDate": "Monday, Feb 10, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 21,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.11",
    "diagDesc": "Acute recurrent frontal sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "bismuth subcitrate 140 MG / Metronidazole 125 MG / tetracycline hydrochloride 125 MG Oral Capsule [Pylera]",
    "medicationDate": "Wednesday, Apr 09, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 28,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "J01.20",
    "diagDesc": "Acute ethmoidal sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 32,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.21",
    "diagDesc": "Acute recurrent ethmoidal sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Minocycline Oral Powder Product",
    "medicationDate": "Tuesday, Mar 11, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 44,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.30",
    "diagDesc": "Acute sphenoidal sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 33,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.31",
    "diagDesc": "Acute recurrent sphenoidal sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Minocycline Oral Powder Product",
    "medicationDate": "Tuesday, Feb 11, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 25,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.40",
    "diagDesc": "Acute pansinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 19,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.41",
    "diagDesc": "Acute recurrent pansinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Ciprofloxacin 250 MG Oral Tablet [Cipro]",
    "medicationDate": "Monday, Feb 10, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 17,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.80",
    "diagDesc": "Other acute sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Ciprofloxacin 500 MG Oral Tablet [Cipro]",
    "medicationDate": "Thursday, Jan 09, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 29,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.81",
    "diagDesc": "Other acute recurrent sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Ciprofloxacin 500 MG Oral Tablet [Cipro]",
    "medicationDate": "Friday, Mar 21, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 40,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.90",
    "diagDesc": "Acute sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 41,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.91",
    "diagDesc": "Acute recurrent sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 35,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.00",
    "diagDesc": "Acute maxillary sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Clarithromycin 50 MG/ML Oral Suspension [Biaxin]",
    "medicationDate": "Monday, Feb 10, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 34,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.01",
    "diagDesc": "Acute recurrent maxillary sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 18,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.10",
    "diagDesc": "Acute frontal sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Erythromycin 250 MG Delayed Release Oral Tablet [Ery-Tab]",
    "medicationDate": "Sunday, Feb 09, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 22,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.11",
    "diagDesc": "Acute recurrent frontal sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Erythromycin 250 MG Delayed Release Oral Tablet [Ery-Tab]",
    "medicationDate": "Tuesday, Mar 11, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 26,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "J01.20",
    "diagDesc": "Acute ethmoidal sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 21,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.21",
    "diagDesc": "Acute recurrent ethmoidal sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 22,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.30",
    "diagDesc": "Acute sphenoidal sinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 45,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.31",
    "diagDesc": "Acute recurrent sphenoidal sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Ofloxacin 400 MG Oral Tablet [Floxin]",
    "medicationDate": "Monday, Feb 10, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 54,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.40",
    "diagDesc": "Acute pansinusitis, unspecified",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 39,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.41",
    "diagDesc": "Acute recurrent pansinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Penicillamine 250 MG Oral Tablet [Depen]",
    "medicationDate": "Friday, Mar 21, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 28,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.80",
    "diagDesc": "Other acute sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "Penicillamine 250 MG Oral Tablet [Depen]",
    "medicationDate": "Monday, Apr 28, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 46,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "J01.81",
    "diagDesc": "Other acute recurrent sinusitis",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "NITROFURANTOIN, MACROCRYSTALS 25 MG Oral Capsule [Macrodantin]",
    "medicationDate": "Tuesday, Feb 11, 2025",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 35,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.90",
    "diagDesc": "Acute sinusitis, unspecified",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1024",
    "measureName": "QPP332",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 19,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "J01.91",
    "diagDesc": "Acute recurrent sinusitis, unspecified",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1029",
    "measureName": "QPP398",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1015",
    "measureName": "QPP155",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1001",
    "measureName": "QPP130",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1008",
    "measureName": "QPP238",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1032",
    "measureName": "QPP464",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1033",
    "measureName": "QPP487",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1002",
    "measureName": "QPP226",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1017",
    "measureName": "QPP236",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1010",
    "measureName": "QPP317",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1031",
    "measureName": "QPP431",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1009",
    "measureName": "QPP128",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1012",
    "measureName": "QPP066",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 25,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "27043",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 16,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "27045",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 18,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "27047",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 21,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "27048",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 28,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "27049",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 32,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "27080",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 44,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "27327",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 33,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "27328",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 25,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "27329",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 19,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "27337",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 17,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "38100",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 29,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "38115",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 40,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "38120",
    "procedureDate": "Monday, Apr 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 41,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "38308",
    "procedureDate": "Tuesday, Jan 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 35,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "38500",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 34,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "38520",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 18,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "38525",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 22,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "43634",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 26,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "43640",
    "procedureDate": "Wednesday, Jan 08, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 21,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "43641",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 22,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "43644",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 45,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "43645",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 54,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "43651",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 39,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "43652",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 28,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "43653",
    "procedureDate": "Monday, Apr 28, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 46,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "44186",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 35,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "44187",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1007",
    "measureName": "QPP355",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 19,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "",
    "diagDesc": "",
    "procedureCode": "44188",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1025",
    "measureName": "QPP356",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1026",
    "measureName": "QPP357",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1021",
    "measureName": "QPP277",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1022",
    "measureName": "QPP279",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1011",
    "measureName": "QPP047",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1020",
    "measureName": "QPP261",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1030",
    "measureName": "QPP419",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1034",
    "measureName": "QPP493",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1027",
    "measureName": "QPP374",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "36",
    "measureName": "QPP472",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "101",
    "firstName": "Joe",
    "lastName": "Smith",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.2",
    "diagDesc": "Chronic serous otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "102",
    "firstName": "Patrick",
    "lastName": "Jones",
    "race": "Black",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.20",
    "diagDesc": "Chronic serous otitis media, unspecified ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "103",
    "firstName": "Rick",
    "lastName": "Wilson",
    "race": "White",
    "gender": "Male",
    "age": 13,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "104",
    "firstName": "Josh",
    "lastName": "Peters",
    "race": "Asian",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0209T",
    "procedureDate": "Wednesday, Apr 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "105",
    "firstName": "Wes",
    "lastName": "Walls",
    "race": "White",
    "gender": "Male",
    "age": 9,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "106",
    "firstName": "Creed",
    "lastName": "Johnson",
    "race": "Black",
    "gender": "Male",
    "age": 8,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Mar 25, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "107",
    "firstName": "Joe",
    "lastName": "Benson",
    "race": "White",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "108",
    "firstName": "Connie",
    "lastName": "Smith",
    "race": "Black",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "109",
    "firstName": "Carla",
    "lastName": "Rubble",
    "race": "Asian",
    "gender": "Female",
    "age": 6,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "110",
    "firstName": "Betty",
    "lastName": "Flintstone",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "111",
    "firstName": "June",
    "lastName": "Sanders",
    "race": "Black",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0212T",
    "procedureDate": "Thursday, Jan 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "112",
    "firstName": "Sarah",
    "lastName": "Andrews",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0212T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "113",
    "firstName": "Wilma",
    "lastName": "Santiago",
    "race": "Black",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "114",
    "firstName": "Peggy",
    "lastName": "Rogers",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Tuesday, Jan 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.4",
    "diagDesc": "Other chronic nonsuppurative otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "115",
    "firstName": "Ray",
    "lastName": "Diaz",
    "race": "White",
    "gender": "Male",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.22",
    "diagDesc": "Chronic serous otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "116",
    "firstName": "Allen",
    "lastName": "Rough",
    "race": "White",
    "gender": "Male",
    "age": 1,
    "encounterDate": "Wednesday, Apr 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.41",
    "diagDesc": "Chronic allergic otitis media",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "117",
    "firstName": "Kyle",
    "lastName": "Stanfield",
    "race": "White",
    "gender": "Male",
    "age": 2,
    "encounterDate": "Sunday, Feb 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.411",
    "diagDesc": "Chronic allergic otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Sunday, Feb 09, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "118",
    "firstName": "Andre",
    "lastName": "Walker",
    "race": "Asian",
    "gender": "Male",
    "age": 11,
    "encounterDate": "Tuesday, Mar 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Mar 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "119",
    "firstName": "Derek",
    "lastName": "Blint",
    "race": "White",
    "gender": "Male",
    "age": 10,
    "encounterDate": "Wednesday, Jan 01, 2025",
    "den": 1,
    "denExcl": 1,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "120",
    "firstName": "Brent",
    "lastName": "Hampson",
    "race": "Black",
    "gender": "Male",
    "age": 6,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "121",
    "firstName": "Randall",
    "lastName": "Riley",
    "race": "White",
    "gender": "Male",
    "age": 5,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.499",
    "diagDesc": "Other chronic nonsuppurative otitis media, unspecified ear",
    "procedureCode": "0209T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "122",
    "firstName": "Ada",
    "lastName": "Myers",
    "race": "Asian",
    "gender": "Female",
    "age": 7,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.30",
    "diagDesc": "Chronic mucoid otitis media, unspecified ear",
    "procedureCode": "0208T",
    "procedureDate": "Monday, Feb 10, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "123",
    "firstName": "Aliah",
    "lastName": "Watson",
    "race": "White",
    "gender": "Female",
    "age": 8,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.31",
    "diagDesc": "Chronic mucoid otitis media, right ear",
    "procedureCode": "0208T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "124",
    "firstName": "Cindy",
    "lastName": "Spangelo",
    "race": "Asian",
    "gender": "Female",
    "age": 9,
    "encounterDate": "Friday, Mar 14, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.32",
    "diagDesc": "Chronic mucoid otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "Friday, Mar 21, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "125",
    "firstName": "Mia",
    "lastName": "Montana",
    "race": "Black",
    "gender": "Female",
    "age": 4,
    "encounterDate": "Monday, Apr 21, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.33",
    "diagDesc": "Chronic mucoid otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, May 06, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "126",
    "firstName": "Molly",
    "lastName": "Mendoza",
    "race": "White",
    "gender": "Female",
    "age": 5,
    "encounterDate": "Tuesday, Feb 04, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 1,
    "diagCode": "H65.491",
    "diagDesc": "Other chronic nonsuppurative otitis media, right ear",
    "procedureCode": "0210T",
    "procedureDate": "Tuesday, Feb 11, 2025",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "127",
    "firstName": "Tia",
    "lastName": "Chen",
    "race": "Asian",
    "gender": "Female",
    "age": 3,
    "encounterDate": "Thursday, Jan 02, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.492",
    "diagDesc": "Other chronic nonsuppurative otitis media, left ear",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  },
  {
    "measureID": "1000",
    "measureName": "QPP318",
    "location": "Loc 1001",
    "patientID": "128",
    "firstName": "Haleigh",
    "lastName": "Hope",
    "race": "White",
    "gender": "Female",
    "age": 2,
    "encounterDate": "Monday, Feb 03, 2025",
    "den": 1,
    "denExcl": 0,
    "num": 0,
    "diagCode": "H65.493",
    "diagDesc": "Other chronic nonsuppurative otitis media, bilateral",
    "procedureCode": "0210T",
    "procedureDate": "",
    "medication": "",
    "medicationDate": "",
    "validated": false,
    "providerID": "123456789",
    "providerName": "Smith, Joe"
  }
];




